import React from 'react';
import useStyle from './appVersionBlock.style';
import { ReactComponent as LogoIcon } from '../../../../assets/svg/logogrey.svg';
import { getAppVersion } from '../../../../helpers/version';

export interface AppVersionBlockProps {
  variant: 'light' | 'normal';
}
export const AppVersionBlock = ({ variant }: AppVersionBlockProps) => {
  const classes = useStyle({ variant });

  return (
    <div className={classes.root}>
      <LogoIcon className={classes.logo} />
      <p className={classes.text}>
        France Challenges - {new Date().getFullYear()}
      </p>
      <p className={classes.text}>Version {getAppVersion()}</p>
    </div>
  );
};
